import styled, { css } from "styled-components";

export const Container = styled.div`
  width: 100%;
  max-width: 420px;
  margin: 0 auto;
  padding: 0;

  display: flex;
  flex-direction: column;
  gap: 14px;
`;

export const Field = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

export const Label = styled.label`
  font-size: 13px;
  font-weight: 600;
  color: #6b7280;
`;

export const controlBase = css`
  width: 100%;
  height: 40px;
  border-radius: 6px;
  border: 1px solid #cfd6e1;
  background: #ffffff;

  padding: 0 12px;
  font-size: 14px;
  font-weight: 500;
  color: #111827;

  box-sizing: border-box;

  &:focus {
    outline: none;
    border-color: #3b82f6;
    box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.18);
  }
`;

export const Input = styled.input`
  ${controlBase};

  ${({ $readOnly }) =>
    $readOnly &&
    css`
      background: #e5e7eb;
      color: #6b7280;
      cursor: not-allowed;
    `}
`;

export const Select = styled.select`
  ${controlBase};
  padding-right: 40px;

  appearance: none;
  background-image: url("data:image/svg+xml,%3Csvg width='18' height='18' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M6 9l6 6 6-6' stroke='%23111827' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 12px center;
  background-size: 18px 18px;
`;

export const ButtonsRow = styled.div`
  width: 100%;
  margin-top: 6px;

  display: grid;
  grid-template-columns: 1.4fr 1fr 0.8fr;
  gap: 12px;

  @media (max-width: 520px) {
    grid-template-columns: 1fr;
  }
`;

export const btnBase = css`
  height: 40px;
  border-radius: 6px;
  font-size: 16px;
  font-weight: 700;
  cursor: pointer;
  padding: 0 12px;
  white-space: nowrap;
`;

export const ButtonOutline = styled.button`
  ${btnBase};
  background: #ffffff;
  color: #0077c8;
  border: 1px solid #0077c8;

  &:hover {
    background: #e6f2fa;
  }
`;

export const ButtonPrimary = styled.button`
  ${btnBase};
  background: #0077c8;
  color: #ffffff;
  border: 1px solid #0077c8;

  &:hover {
    background: #005a9a;
    border-color: #005a9a;
  }
`;
